import { render, staticRenderFns } from "./DatadogNewOracle.vue?vue&type=template&id=656894a7&scoped=true"
import script from "./DatadogNewOracle.vue?vue&type=script&lang=js"
export * from "./DatadogNewOracle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656894a7",
  null
  
)

export default component.exports